import { combineReducers } from 'redux';

import { ConnectedActionHandlerMap as coreReducer, namespace as coreNamespace } from './core/ltl.core.reducer';
import { ConnectedActionHandlerMap as gridReducer, namespace as gridNamespace } from './grid/ltl.grid.reducer';

export const reduce = combineReducers({
  [coreNamespace]: coreReducer,
  [gridNamespace]: gridReducer,
});

// eslint-disable-next-line no-barrel-files/no-barrel-files
export { namespace } from './ltl.reducer.metadata';
